module.exports = __webpack_public_path__ + "static/media/image_1x2.d35f3515.png";